import { render, staticRenderFns } from "./identifyConp.vue?vue&type=template&id=f871ef5c&"
import script from "./identifyConp.vue?vue&type=script&lang=js&"
export * from "./identifyConp.vue?vue&type=script&lang=js&"
import style0 from "./identifyConp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports